import { AbandonWriteErrorName } from './AbandonWriteError';
import { CallbackProcessingErrorName } from './CallbackProcessingError';
import { InvalidPolicyErrorName } from './InvalidPolicyError';
export const shouldIgnoreResilienceDbError = error => {
  if (error && typeof error === 'object' && 'name' in error) {
    const errorWithName = error;
    return typeof errorWithName.name === 'string' && (errorWithName.name === AbandonWriteErrorName || errorWithName.name === CallbackProcessingErrorName || errorWithName.name === InvalidPolicyErrorName);
  }
  return false;
};